import {Attachment} from '../../Attachment';
import {SimpleWorkspaceUser} from './SimpleWorkspaceUser';
import {WorkspaceUserWithAvatar} from '../interfaces/WorkspaceUserWithAvatar';

export class SimpleWorkspaceAgentListElement extends SimpleWorkspaceUser implements WorkspaceUserWithAvatar {
}
